import React, { useContext, useEffect, useReducer, useState } from 'react';

import { Button, Modal, Tab } from 'react-bootstrap';
import InputField from '../../../components/Fields/inputFields';
import Select from "react-select";
import { getInvoicesType } from '../../../../service/bankApi/getInvoiceTypes';
import { useDispatch } from 'react-redux';
import { addVendorApi } from '../../../../service/vendor/addVendorApi';
import SelectInputInvoiceType from '../../../components/Fields/selectInputInvoiceType';
import { emailValidation, phoneOnChange, phoneValidation } from '../../../../function/validation';
import { updateVendorApi } from '../../../../service/vendor/updateVendor';
import { setLoading } from '../../../../feature/authSlice';
import { ifscApi } from '../../../../service/bankApi/ifscApi';
import { maskAccountNumber, maskConfirmAccountNumber, maskGSTIN, maskPAN } from '../../auth/maskingFunction';
import { toast } from 'react-toastify';






const AddVendorModal = ({
  vendorModalView,
  handleVendorModalView,
  modalType,
  vendorData
}) => {

  const dispatch = useDispatch()
  const [invoiceTypeArr, setInvoiceTypeArr] = useState([]);

  const [selectInvoiceTypeError, setSelectInvoiceTypeError] = useState(false)
  const [selectedOption, setSelectedOption] = useState("");

  const [nameVal, setNameVal] = useState("")
  const [isNameValError, setIsNameValError] = useState(false)
  const [vendorCode, setVendorCode] = useState("")
  const [isVendorCodeError, setIsVendorCodeError] = useState(false)
  const [vendorSite, setVendorSite] = useState("")
  const [isVendorSiteError, setIsVendorSiteError] = useState(false)
  const [phonenumber, setPhonenumber] = useState("")
  const [isPhonenumberError, setIsPhonenumberError] = useState(false)
  const [email, setEmail] = useState("")
  const [isEmailError, setIsEmailError] = useState(false)
  const [gstin, setGstin] = useState("")
  const [isGstinError, setIsGstinError] = useState(false)
  const [pan, setPan] = useState("")
  const [isPanError, setIsPanError] = useState(false)
  const [aadhaar, setAadhaar] = useState("")
  const [isAadhaarError, setIsAadhaarError] = useState(false)
  const [branchCode, setBranchCode] = useState("")
  const [isBranchCodeError, setIsBranchCodeError] = useState(false)
  const [apiLoading, setApiLoading] = useState(false)
  const [isInvoiceTypeError, setIsIsInvoiceTypeError] = useState(false)
  const [accountNumber,setAccount]=useState("")
  const [isAccountError,setIsAccountError]=useState(false)
  const [ifscCode,setIfscCode]=useState("")
  const [isIfscError,setIsIfscError]=useState(false)
  const [bankName,setBankName]=useState("")
  const [isBankNameError,setIsBankNameError]=useState(false)
  const [cityName,setCityName]=useState("")
  const [isCityNameError,setIsCityNameError]=useState(false)
  const [confirmAccountNumber,setConfirmAccountNumber]=useState("")
  const [isConfirmAccountNumberError,setIsConfirmAccountNumberError]=useState(false)
  const [isVerified,setIsVerified]=useState(false)
  const [isEnabled,setIsEnabled]=useState(false)
  const [customerAccountNumber,setCustomerAccountNumber]=useState("")
  const [customerAccountNumberError,setCustomerAccountNumberError]=useState("")
  const [isCustomerAccountNumberEnabled,setIsCustomerAccountNumberEnabled]=useState(false)
  const [displayValue,setDisplayValue]=useState("")

  useEffect(() => {

    dispatch(
      getInvoicesType({}, (res) => {
        setInvoiceTypeArr(res.data.result);

      })
    );
    if (modalType === 2) {
      setInitialState(vendorData)
    }


    return () => {

    }

  }, []);
  function resetState() {
    setNameVal("")
    setIsNameValError(false)
    setVendorCode("")
    setIsVendorCodeError(false)
    setVendorSite("")
    setIsVendorSiteError(false)
    setPhonenumber("")
    setIsPhonenumberError(false)
    setEmail("")
    setIsEmailError(false)
    setGstin("")
    setIsGstinError(false)
    setPan("")
    setIsPanError(false)
    setAadhaar("")
    setIsAadhaarError(false)
    setBranchCode("")
    setIsBranchCodeError(false)
    setAccount("")
    setIsAccountError(false)
    setConfirmAccountNumber("")
    setIsConfirmAccountNumberError(false)
    setIfscCode("")
    setIsIfscError(false)
    setBankName("")
    setIsBankNameError(false)
    setCityName("")
    setIsCityNameError(false)
  }

  function setInitialState(data) {
    setSelectedOption(data?.Type)
    setNameVal(data?.VendorName)
    setVendorCode(data?.VendorCode)
    setVendorSite(data?.VendorSite)
    setPhonenumber(data?.VendorPhone)
    setEmail(data?.VendorEmail)
    setGstin(data?.VendorGSTIN)
    setPan(data?.VendorPAN)
    setAadhaar(data?.VendorAadhar)
    setBranchCode(data?.VendorCode)
    setCustomerAccountNumber(data?.CustomerAccountNo)
    setAccount(data?.BankDetails?.AccountNumber)
    setConfirmAccountNumber(data?.BankDetails?.AccountNumber)
    setIfscCode(data?.BankDetails?.IFSC)
    setBankName(data?.BankDetails?.BankName)
    setCityName(data?.BankDetails?.BankCity)
    setIsVerified(data?.BankDetails?.IsBankVerified)
    if(vendorData?.Type?.includes("Telephone")){
      setIsCustomerAccountNumberEnabled(true)
    }else{
      setIsCustomerAccountNumberEnabled(false)
    }
  }


  function handleValueSelected(e) {
    setSelectInvoiceTypeError(false)
    setSelectedOption(e.target.value);
    if((e.target.value.includes("Telephone"))){
    setIsCustomerAccountNumberEnabled(true)
    }else{
      setIsCustomerAccountNumberEnabled(false)
    }
  }
  function handleName(e) {
    setIsNameValError(false)
    setNameVal(e.target.value);

  }

  function handleVendorCode(e) {
    setIsVendorCodeError(false)
    setVendorCode(e.target.value);

  }
  function handleBranchCode(e) {
    setIsBranchCodeError(false)
    setBranchCode(e.target.value);

  }
  function handleVendorSite(e) {
    setIsVendorSiteError(false)
    setVendorSite(e.target.value);

  }
  function handlePhonenumber(e) {


    setIsPhonenumberError(false)
    phoneOnChange(e.target.value) && setPhonenumber(e.target.value)

  }
  function handleEmail(e) {
    setIsEmailError(false)
    setEmail(e.target.value);

  }
  function handleGstin(e) {
    setIsGstinError(false)
    setGstin(e.target.value);

  }

  function handleAdhaar(e) {
    setIsAadhaarError(false)
    setAadhaar(e.target.value);

  }
  function handlePan(e) {
    setIsPanError(false)
    setPan(e.target.value);

  }
  const handleAccount=(e)=>{
    setIsAccountError(false)
    const value = e.target.value.slice(0, 20);
      setAccount(value);
  }
  const handleIfsc=(e)=>{
    setIsIfscError(false)
    const slicedIfscCode = e.target.value.slice(0, 11);
    setIfscCode(slicedIfscCode);
  }
  const handleBank=(e)=>{
    setIsBankNameError(false)
      setBankName(e.target.value);
  }
  const handleCity=(e)=>{
    setIsCityNameError(false)
      setCityName(e.target.value);
  }
  const handleCustomerAccountNumber=(e)=>{
    setCustomerAccountNumberError(false)
    const value = e.target.value.slice(0, 20);
      setCustomerAccountNumber(value);
  }
  const handleConfirmAccountNumber=(e)=>{
    setIsConfirmAccountNumberError(false)
    const value = e.target.value.slice(0, 20);
      setConfirmAccountNumber(value);
  }

  function  handleAddVendorApiCall() {
    if (selectedOption === "") {
      setSelectInvoiceTypeError(true)
    }
    if (nameVal === "") {
      setIsNameValError(true)
    }
    if (vendorCode === "") {
      setIsVendorCodeError(true)
    }
    if (vendorSite === "") {
      setIsVendorSiteError(true)
    }
    if (phonenumber.length<10) {
      setIsPhonenumberError(true)
    }
    if (!emailValidation(email)) {
      setIsEmailError(true)
    }
    if (gstin === "") {
      setIsGstinError(true)
    }
    if (pan === "") {
      setIsPanError(true)
    }
    if (branchCode === "") {
      setIsBranchCodeError(true)
    }
    if (aadhaar === "") {
      setIsAadhaarError(true)
    }
if(isCustomerAccountNumberEnabled===true && accountNumber===""){
setIsAccountError(true)
}
if(isCustomerAccountNumberEnabled===true && confirmAccountNumber!==accountNumber){
setIsConfirmAccountNumberError(true)
}else{
setIsConfirmAccountNumberError(false)
}
if(isCustomerAccountNumberEnabled===true && bankName===""){
setIsBankNameError(true)
}
if(isCustomerAccountNumberEnabled===true && cityName===""){
setIsCityNameError(true)
}
if(isCustomerAccountNumberEnabled===true && ifscCode===""){
setIsIfscError(true)
}
if(isCustomerAccountNumberEnabled===true && customerAccountNumber===""){
setCustomerAccountNumberError(true)    
}
if (selectedOption !== '' && nameVal !== "" && phonenumber.length===10 && vendorCode !== "" && vendorSite !== ""  && emailValidation(email) && gstin !== "" && pan !== "" && isCustomerAccountNumberEnabled===false) {
  if (modalType === 2) {
    var data = {
      Id: vendorData.Id,
      Type: selectedOption,
      VendorName: nameVal,
      VendorCode: vendorCode,
      VendorSite: vendorSite,
      VendorPhone: phonenumber,
      VendorEmail: email,
      VendorGSTIN: gstin,
      VendorPAN: pan,
      VendorAadhar: aadhaar,
      AccountNumber: accountNumber,
      IFSC: ifscCode,
      BankName: bankName,
      BankCity: cityName,
      IsBankVerified: isVerified,
      CustomerAccountNo:customerAccountNumber
    }

    dispatch(updateVendorApi(data, () => {
      setApiLoading(true)
      resetState()
      toast.success("Vendor Updated Successfully")
      setApiLoading(false)
      
      handleVendorModalView()
    }, () => {
      setApiLoading(false)
      
    }))
  }
   if(modalType===1) {
    var data = {
      Type: selectedOption,
      VendorName: nameVal,
      VendorCode: vendorCode,
      VendorSite: vendorSite,
      VendorPhone: phonenumber,
      VendorEmail: email,
      VendorGSTIN: gstin,
      VendorPAN: pan,
      VendorAadhar: aadhaar,
      BranchCode: branchCode,
      BranchCode: branchCode,
      AccountNumber: accountNumber,
      IFSC: ifscCode,
      BankName: bankName,
      BankCity: cityName,
      IsBankVerified: false,
      CustomerAccountNo:customerAccountNumber
    }
    dispatch(addVendorApi(data, () => {
      setApiLoading(true)
      resetState()
      toast.success("Vendor Added Successfully")
      setApiLoading(false)
      
      handleVendorModalView()
    }, () => {
      setApiLoading(false)
      
    }))
  }
}
if (selectedOption !== '' && nameVal !== "" &&phonenumber.length===10 && vendorCode !== "" && vendorSite !== ""  && emailValidation(email) && gstin !== "" && pan !== "" && isCustomerAccountNumberEnabled===true &&accountNumber!=='' && confirmAccountNumber===accountNumber&&bankName!==''&&ifscCode!==''&&cityName!==''&&customerAccountNumber!=='') {
  if (modalType === 2) {
    var data = {
      Id: vendorData.Id,
      Type: selectedOption,
      VendorName: nameVal,
      VendorCode: vendorCode,
      VendorSite: vendorSite,
      VendorPhone: phonenumber,
      VendorEmail: email,
      VendorGSTIN: gstin,
      VendorPAN: pan,
      VendorAadhar: aadhaar,
      AccountNumber: accountNumber,
      IFSC: ifscCode,
      BankName: bankName,
      BankCity: cityName,
      IsBankVerified: isVerified,
      CustomerAccountNo:customerAccountNumber
    }

    dispatch(updateVendorApi(data, () => {
      setApiLoading(true)
      resetState()
      toast.success("Vendor Updated Successfully")
      setApiLoading(false)
      
      handleVendorModalView()
    }, () => {
      setApiLoading(false)
      
    }))
  }
   if(modalType===1) {
    var data = {
      Type: selectedOption,
      VendorName: nameVal,
      VendorCode: vendorCode,
      VendorSite: vendorSite,
      VendorPhone: phonenumber,
      VendorEmail: email,
      VendorGSTIN: gstin,
      VendorPAN: pan,
      VendorAadhar: aadhaar,
      BranchCode: branchCode,
      BranchCode: branchCode,
      AccountNumber: accountNumber,
      IFSC: ifscCode,
      BankName: bankName,
      BankCity: cityName,
      IsBankVerified: false,
      CustomerAccountNo:customerAccountNumber
    }
    dispatch(addVendorApi(data, () => {
      setApiLoading(true)
      resetState()
      toast.success("Vendor Added Successfully")
      setApiLoading(false)
      
      handleVendorModalView()
    }, () => {
      setApiLoading(false)
      
    }))
  }
}
  }

const getBankData=()=>{
  dispatch(setLoading(true))
  dispatch(ifscApi(ifscCode, (res) => {
setBankName(res?.data?.result?.bank)
setCityName(res?.data?.result?.city)
dispatch(setLoading(false))
  }, () => {}))
dispatch(setLoading(false))
}

useEffect(() => {
  if(ifscCode?.length===11){
  getBankData()
  }
}, [ifscCode])


  return (
    <>

      <Modal className="fade" size='lg' show={vendorModalView} centered>
        <Modal.Header>
          <Modal.Title>{modalType === 1 ? "Add Vendor" : "Update Vendor"}</Modal.Title>

        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => e.preventDefault()}>
            <SelectInputInvoiceType disabled={modalType===2?true:false} options={invoiceTypeArr} defaultValue={selectedOption} labelName={"Select Service Type *"} onChange={handleValueSelected} errorMessage={"Please select a invoice type"}  errorOccured={selectInvoiceTypeError} />
            <InputField labelName={"Name *"} disabled={modalType===2?true:false} onChange={handleName} value={nameVal} errorMeesage={"Please enter valid name"} errorOccured={isNameValError} />
            <InputField labelName={"Vendor Site *"} disabled={modalType===2?true:false} onChange={handleVendorSite} value={vendorSite} errorMeesage={"Please enter valid Vendor Site"} errorOccured={isVendorSiteError} />


            <div className='row' >
              <div className='col-6'>
                <InputField labelName={"Vendor Code *"} disabled={modalType===2?true:false} onChange={handleVendorCode} value={vendorCode} errorMeesage={"Please enter valid Vendor Code"} errorOccured={isVendorCodeError} />

              </div>
              {/* <div className='col-6'>
                <InputField labelName={"Branch Code *"} onChange={handleBranchCode} value={branchCode} errorMeesage={"Please enter valid Branch Code"} errorOccured={isBranchCodeError} />

              </div> */}
      <div className='col-6'>
                <InputField labelName={"Phone Number"} onChange={handlePhonenumber} value={phonenumber} errorMeesage={"Phone number must be of 10 digits"} errorOccured={isPhonenumberError} />
              </div>
            </div>
            <div className='row' >
              <div className='col-6'>
                <InputField labelName={"Email *"} onChange={handleEmail} value={email} errorMeesage={"Please enter valid Email"} errorOccured={isEmailError} />
              </div>
              <div className='col-6'>
                <InputField labelName={"GSTIN*"} disabled={modalType===2?true:false} onChange={handleGstin} value={modalType===2?maskGSTIN(gstin):gstin} errorMeesage={"Please enter valid GSTIN"} errorOccured={isGstinError} />
              </div>
            </div>

            <div className='row' >
          
              <div className='col-6'>
                <InputField labelName={"Aadhaar"} disabled={modalType===2?true:false} onChange={handleAdhaar} value={aadhaar}/>
              </div>
<div className='col-6'>
<InputField labelName={"PAN*"} disabled={modalType===2?true:false} onChange={handlePan} value={modalType===2?maskPAN(pan):pan} errorMeesage={"Please enter valid Pan"} errorOccured={isPanError} />

</div>
{isCustomerAccountNumberEnabled &&(
<div className='col-6'>
<InputField labelName={"Account Number*"} onChange={handleAccount} value={accountNumber} errorMeesage={"Please enter valid account number"} errorOccured={isAccountError} />

</div>
)}
{isCustomerAccountNumberEnabled &&(
  <div className='col-6'>
  <InputField type='password' labelName={"Confirm Account Number*"} onChange={handleConfirmAccountNumber} value={modalType===2?confirmAccountNumber:confirmAccountNumber} errorMeesage={"Account numbers should match"} errorOccured={isConfirmAccountNumberError} />
  
  </div>
)}
{isCustomerAccountNumberEnabled &&(
<div className='col-6'>
<InputField labelName={"Customer Account Number*"} disabled={modalType===2?true:false} onChange={handleCustomerAccountNumber} value={customerAccountNumber} errorMeesage={"Please enter valid customer account number"} errorOccured={customerAccountNumberError} />

</div>
)}
{isCustomerAccountNumberEnabled &&(
<div className='col-6'>
<InputField labelName={"IFSC*"} onChange={handleIfsc} value={ifscCode} errorMeesage={"Please enter valid ifsc code"} errorOccured={isIfscError} />

</div>
)}
{isCustomerAccountNumberEnabled &&(
<div className='col-6'>
<InputField labelName={"Bank Name*"} disabled={modalType===2?true:false} onChange={handleBank} value={bankName} errorMeesage={"Please enter valid bank name"} errorOccured={isBankNameError} />

</div>
)}
{isCustomerAccountNumberEnabled &&(
<div className='col-6'>
<InputField labelName={"City*"} disabled={modalType===2?true:false} onChange={handleCity} value={cityName} errorMeesage={"Please enter valid city name"} errorOccured={isCityNameError} />

</div>
)}
            </div>





          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button

            variant="danger light"
            onClick={handleVendorModalView}
          >
            Close
          </Button>
{isEnabled && (
            <button

            className="btn btn-primary"
            onClick={handleAddVendorApiCall}
            disabled={apiLoading}
          >
            {apiLoading ? "Saving " : "Save"}
          </button>
)}
{isEnabled===false && (
            <button

            className="btn btn-primary"
            onClick={handleAddVendorApiCall}
            disabled={apiLoading}
          >
            {apiLoading ? "Submitting " : "Submit"}
          </button>
)}
        </Modal.Footer>
      </Modal>

    </>
  )
}
export default AddVendorModal; 